import React, { Component } from 'react'

import { CrfContext } from '../../CrfContext'

import SideNav from '../sidenav/Sidenav'
import { Link } from 'react-router-dom'
import Filter from './filter/filter'
import './SystemUsers.css'

import axios from 'axios'

export class SystemUsers extends Component {
  state = {
    approvedRequest: false,
    allRequests: [],
    departmentLists: [],
    selectedDepartment: '',
    department: [''],
    filters: []
  }

  componentDidMount () {
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/userInfo/userList`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
          
        this.setState({
          allRequests: response.data.data,
          filters: response.data.data
        })
        //     
      })
      .catch(error => {
          
      })

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/departments`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
          
        this.setState({
          departmentLists: response.data.data
        })
        //   
      })
      .catch(error => {
        //   
      })
  }

  handleChangeRole = e => {
      
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_API_KEY}/api/userInfo/${e.target.id}`,
      data: { roles: `${e.target.value}` },
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
          
      })
      .catch(error => {
          
      })
  }

  handleViewFullDept = async e => {
    try {
      document.getElementById(`departmentFullList${e.target.id}`)
      document.getElementById(
        `departmentFullList${e.target.id}`
      ).style.display = 'block'
    } catch (error) {
        
    }
  }

  handleCloseViewDept = e => {
    e.target.parentElement.parentElement.style.display = 'none'
  }

  handleRequestForDepartment = e => {
    // e.preventDefault()
      
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_API_KEY}/api/userInfo/departmentRequest/${e.target.id}`,
      data: {
        department: this.state.selectedDepartment
      },
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
          
        window.location.reload()
      })

      .catch(error => {})
  }

  handleSelectDepartment = e => {
    this.setState({
      selectedDepartment: e.target.value
    })
  }

  handleRemoveDept = e => {
      
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_API_KEY}/api/userInfo/removedDepartment/${e.target.id}`,
      data: {
        department: e.target.name
      },
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
          
        if (response.data.data.nModified !== 0) {
          window.location.reload()
        }
      })
      .catch(error => {
          
      })
  }

  handleSearch = value => {
    if (value.length > 0) {
      this.setState({
        filters: value
      })
    } else {
      this.setState({
        filters: this.state.allRequests
      })
    }
  }

  render () {
    const allRequests = this.state.filters

    return (
      <CrfContext.Consumer>
        {context => (
          <div id='mainPage'>
            <div id='sidePanel'>
              <SideNav
                testState={context.state.testState}
                toggleBtn1List={context.toggleBtn1List}
                toggleBtn2List={context.toggleBtn2List}
                btn1List={context.state.btn1List}
                btn2List={context.state.btn2List}
                userRole={context.state.userRole}
              />
            </div>
            <div id='mainPanel'>
              <div className='requestSelectionPanel'>
                <div className='toApproveHeader'>
                  <div className='headerAccountingM'>
                    <div className='itemAccountingM'>
                      <h1>System Users</h1>
                    </div>
                    <div
                      style={{
                        paddingTop: '1.5rem',
                        paddingRight: '1rem',
                        overflow: 'auto'
                      }}
                    >
                      Filter:
                    </div>
                    <div
                      className='itemAccountingM'
                      style={{
                        paddingTop: '1rem',
                        height: '4rem',
                        overflow: 'auto'
                      }}
                    >
                      <Filter
                        search={this.handleSearch}
                        allRequests={this.state.allRequests}
                      />
                    </div>
                  </div>
                  {/* TABLE HEAD */}
                  <div className='myRequestTableHeader'>
                    <div className='tHeadSystemUsers1'>
                      <h4>User</h4>
                    </div>
                    <div className='tHeadSystemUsers2'>
                      <h4>Email</h4>
                    </div>
                    <div className='tHeadSystemUsers3'>
                      <h4>Department</h4>
                    </div>
                    <div className='tHeadSystemUsers3'>
                      <h4>Role</h4>
                    </div>
                  </div>
                  {/*END TABLE HEAD */}
                </div>
              </div>
              {/* TABLE DATA */}
              <div className='divisionToApprove'></div>
              {allRequests.map((requestsArray, index) => (
                <div className='tableDataSystemUsers'>
                  <div className='userDataTable'>
                    {requestsArray.firstName + ' ' + requestsArray.lastName}
                  </div>
                  <div className='userDataTable2'>
                    <h4>{requestsArray.email}</h4>
                  </div>
                  <div className='userDataTable3'>
                    <>
                      <>
                        <button
                          type='button'
                          id={`toggleView${index}`}
                          onClick={this.handleViewFullDept}
                          className='departmentDropDown'
                        >
                          {this.state.allRequests.filter(
                            (user, index) => user._id === requestsArray._id
                          )[0].departments.length !== 0 ? (
                            <i class='fas fa-chevron-down' id={index}></i>
                          ) : (
                            <i class='fas fa-plus' id={index}></i>
                          )}
                        </button>

                        {this.state.allRequests.filter(
                          (user, index) => user._id === requestsArray._id
                        )[0].departments.length !== 0 ? (
                          <span>
                            {
                              this.state.allRequests.filter(
                                user => user._id === requestsArray._id
                              )[0].departments[0].centerName
                            }
                          </span>
                        ) : (
                          <span>No Department</span>
                        )}
                        <div
                          className='departmentFullList'
                          id={`departmentFullList${index}`}
                        >
                          <div className='closeDepartmentList'>
                            <button
                              type='button'
                              onClick={this.handleCloseViewDept}
                              className='closeViewDeptBtn'
                            >
                              &times;
                            </button>
                          </div>
                          {this.state.allRequests.filter(
                            (user, index) => user._id === requestsArray._id
                          )[0].departments.length !== 0 ? (
                            <>
                              {this.state.allRequests
                                .filter(
                                  user => user._id === requestsArray._id
                                )[0]
                                .departments.map(depts => (
                                  <div className='departmentNameContainer'>
                                    <div className='deptName'>
                                      {/* <button type="button">
                                                    <i class="fas fa-thumbs-up"></i>
                                                </button> */}
                                      <span>{depts.centerName}</span>
                                    </div>
                                    <div className='deptApproveBtnContainer'>
                                      <button
                                        id={requestsArray._id}
                                        name={depts.centerName}
                                        type='button'
                                        onClickCapture={this.handleRemoveDept}
                                      >
                                        &times;
                                      </button>
                                    </div>
                                  </div>
                                ))}
                            </>
                          ) : null}

                          <div className='addDepartmentContainer'>
                            <div className='deptInputContainer'>
                              <input
                                id={index}
                                onChange={this.handleSelectDepartment}
                                list='deptList'
                                type='text'
                                placeholder='Choose Department'
                                className='addDeptInput'
                              />
                            </div>

                            <div className='deptAddBtnContainer'>
                              {/* <button type="button" className="addDeptBtn">
                                                   Add
                                                </button> */}
                              <button
                                id={requestsArray._id}
                                onClick={this.handleRequestForDepartment}
                                type='button'
                                className='addApproveDeptBtn'
                              >
                                Add and Approve
                              </button>
                            </div>
                          </div>
                        </div>
                      </>

                      <datalist id='deptList'>
                        {this.state.departmentLists.map(data => (
                          <option value={data} />
                        ))}
                      </datalist>
                    </>
                  </div>

                  <div className='userDataTable3'>
                    <select
                      name={'name'}
                      id={requestsArray._id}
                      onChange={this.handleChangeRole}
                    >
                      <option value={requestsArray.roles[0]}>
                        {requestsArray.roles[0]}
                      </option>
                      <option value='Requestor'>Requestor</option>
                      <option value='Department Head'>Department Head</option>
                      <option value='Accounting Staff'>Accounting Staff</option>
                      <option value='Accounting Supervisor'>Accounting Supervisor</option>
                      <option value='Accounting Manager'>
                        Accounting Manager
                      </option>
                      <option value='President'>President</option>
                      <option value='CEA'>CEA</option>
                    </select>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </CrfContext.Consumer>
    )
  }
}

const link = {
  textDecoration: 'none',
  color: 'black'
}

export default SystemUsers
